import { memo, type ReactNode, useState } from 'react'

import { useIsMobile } from '@/hooks/use-mobile.hook'

import { SettingsLayoutDesktop } from './settings-layout-desktop.molecule'
import { SettingsLayoutMobile } from './settings-layout-mobile.molecule'
import type { SettingsNavGroup, SettingsNavItem } from './settings-nav-item.interface'

export interface SettingsLayoutProps {
  groupList: SettingsNavGroup[]
  activeItemId: string
  onNavigate: (item: SettingsNavItem) => void
  children: ReactNode
  sidebarTitle?: string
  contentTitle?: string
  contentDescription?: string
  className?: string
}

const SettingsLayoutBase: React.FC<SettingsLayoutProps> = ({
  groupList,
  activeItemId,
  onNavigate,
  children,
  sidebarTitle,
  contentTitle,
  contentDescription,
  className,
}): ReactNode => {
  const isMobile = useIsMobile()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const handleItemClick = (item: SettingsNavItem): void => {
    onNavigate(item)
    setIsMobileMenuOpen(false)
  }

  if (isMobile) {
    return (
      <SettingsLayoutMobile
        groupList={groupList}
        activeItemId={activeItemId}
        onItemClick={handleItemClick}
        sidebarTitle={sidebarTitle}
        contentTitle={contentTitle}
        contentDescription={contentDescription}
        className={className}
        isMobileMenuOpen={isMobileMenuOpen}
        onMobileMenuOpenChange={setIsMobileMenuOpen}
      >
        {children}
      </SettingsLayoutMobile>
    )
  }

  return (
    <SettingsLayoutDesktop
      groupList={groupList}
      activeItemId={activeItemId}
      onItemClick={handleItemClick}
      sidebarTitle={sidebarTitle}
      contentTitle={contentTitle}
      contentDescription={contentDescription}
      className={className}
    >
      {children}
    </SettingsLayoutDesktop>
  )
}

export const SettingsLayout = memo(SettingsLayoutBase)

SettingsLayout.displayName = 'SettingsLayout'
